import {
  Button,
  PageContainer,
  Typography,
} from "@sidelinesports/fan-design-system";
import type { FC } from "react";
import { Page } from "../../analytics/Page.tsx";
import { LoadErrorVector } from "../../assets/index.ts";
import {
  FullscreenLayout,
  IllustratedMessage,
} from "../../components/index.tsx";

export const ErrorScreen: FC<
  React.PropsWithChildren<{
    error?: unknown;
    onRetry?: () => void;
  }>
> = ({ onRetry = reload }) => (
  <Page name="ErrorScreen">
    <PageContainer data-surface-color="dark">
      <FullscreenLayout>
        <IllustratedMessage
          illustration={<LoadErrorVector fontSize="12.5rem" />}
        >
          <Typography size="lg" textAlign="center" color="readable">
            Something went wrong while loading this page. Sorry about that!
          </Typography>
          <Button variant="outline" onClick={onRetry}>
            Try Again
          </Button>
        </IllustratedMessage>
      </FullscreenLayout>
    </PageContainer>
  </Page>
);

function reload() {
  window.location.reload();
}
